/**
 * Admin Moderation Feature - Update
 * 
 * Elm-ish architecture: Pure state transition function.
 * Takes model + message, returns new model.
 */

import { AdminModerationModel } from './model';
import { Msg } from './messages';

export function update(model: AdminModerationModel, msg: Msg): AdminModerationModel {
  switch (msg.type) {
    case 'queue-load-started':
      return {
        ...model,
        loading: true,
        error: null,
        actionSuccess: false,
      };

    case 'queue-loaded':
      return {
        ...model,
        queue: msg.items,
        hasMore: msg.hasMore,
        loading: false,
        error: null,
      };

    case 'queue-load-error':
      return {
        ...model,
        loading: false,
        error: msg.error,
      };

    case 'item-selected':
      return {
        ...model,
        selectedItem: msg.item,
        pendingAction: null,
        actionSuccess: false,
      };

    case 'item-deselected':
      return {
        ...model,
        selectedItem: null,
        pendingAction: null,
        actionSuccess: false,
      };

    case 'approve-intent':
      return {
        ...model,
        selectedItem: msg.item,
        pendingAction: 'approve',
        actionSuccess: false,
      };

    case 'reject-intent':
      return {
        ...model,
        selectedItem: msg.item,
        pendingAction: 'reject',
        actionSuccess: false,
      };

    case 'action-confirmed':
      // Optimistic update - remove from queue if item selected
      if (model.selectedItem && model.pendingAction) {
        return {
          ...model,
          queue: model.queue.filter(item => item.id !== model.selectedItem!.id),
          selectedItem: null,
          pendingAction: null,
        };
      }
      // Reset pending action even without selection
      return {
        ...model,
        pendingAction: null,
      };

    case 'action-cancelled':
      return {
        ...model,
        pendingAction: null,
        actionSuccess: false,
      };

    case 'action-success':
      return {
        ...model,
        actionSuccess: true,
      };

    case 'action-error':
      return {
        ...model,
        pendingAction: null,
        error: msg.error,
      };

    case 'load-more':
      return {
        ...model,
        loading: true,
        page: model.page + 1,
      };

    case 'page-changed':
      return {
        ...model,
        page: msg.page,
      };

    default:
      return model;
  }
}